"use strict";
/*
 * Copyright (C) 2021 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i64Field = exports.SignedNumberField = exports.parsePosition = exports.StaticSeeds = void 0;
const BL = __importStar(require("@solana/buffer-layout"));
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
var StaticSeeds;
(function (StaticSeeds) {
    StaticSeeds["Collateral"] = "collateral";
    StaticSeeds["Deposits"] = "deposits";
    StaticSeeds["DexOpenOrders"] = "dex-open-orders";
    StaticSeeds["DexSwapTokens"] = "dex-swap-tokens";
    StaticSeeds["FeeVault"] = "fee-vault";
    StaticSeeds["Loans"] = "loans";
    StaticSeeds["Obligation"] = "obligation";
    StaticSeeds["Vault"] = "vault";
})(StaticSeeds = exports.StaticSeeds || (exports.StaticSeeds = {}));
const parsePosition = (position) => ({
    account: new web3_js_1.PublicKey(position.account),
    amount: new anchor_1.BN(position.amount),
    side: position.side,
    reserveIndex: position.reserveIndex,
    _reserved: []
});
exports.parsePosition = parsePosition;
/**
 * TODO:
 * @export
 * @class SignedNumberField
 * @extends {BL.Layout}
 */
class SignedNumberField extends BL.Layout {
    /**
     * Creates an instance of SignedNumberField.
     * @param {number} span
     * @param {string} [property]
     * @memberof SignedNumberField
     */
    constructor(span, property) {
        super(span, property);
    }
    /**
     * TODO:
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {BN}
     * @memberof SignedNumberField
     */
    decode(b, offset) {
        const start = offset == undefined ? 0 : offset;
        const data = b.slice(start, start + this.span);
        return new anchor_1.BN(data, undefined, "le").fromTwos(this.span * 8);
    }
    /**
     * TODO:
     * @param {BN} src
     * @param {Uint8Array} b
     * @param {number} [offset]
     * @returns {number}
     * @memberof SignedNumberField
     */
    encode(src, b, offset) {
        const start = offset == undefined ? 0 : offset;
        b.set(src.toTwos(this.span * 8).toArray("le"), start);
        return this.span;
    }
}
exports.SignedNumberField = SignedNumberField;
/**
 * Returns a signed number field that is 8 bytes wide
 * @export
 * @param {string} [property]
 * @returns {SignedNumberField}
 */
function i64Field(property) {
    return new SignedNumberField(8, property);
}
exports.i64Field = i64Field;
//# sourceMappingURL=util.js.map